export default from './svg';



// WEBPACK FOOTER //
// ./src/components/atoms/Svg/index.js